import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';
import {
  IsActiveMatchOptions,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';

import { IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [RouterLink, RouterLinkActive, IconModule, TranslateModule],
  selector: 'iw-routing-item',
  template: `
    <a
      [routerLink]="link()"
      class="link"
      [routerLinkActiveOptions]="activeOptions"
      routerLinkActive="active"
      #rla="routerLinkActive"
    >
      <fu-icon class="icon" [iconName]="iconName()" [size]="iconSize()" />
    </a>
    <span class="name" [class.active]="rla.isActive">
      {{ i18nKey() | translate }}
    </span>
  `,
  styleUrl: './routing-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoutingItemComponent {
  readonly link = input<string | string[]>();
  readonly iconName = input<string>();
  readonly i18nKey = input<string>();
  readonly iconSize = input<number>(24);
  readonly exactRoute = input(false, { transform: booleanAttribute });

  get activeOptions(): { exact: boolean } | IsActiveMatchOptions {
    return this.exactRoute()
      ? {
          paths: 'exact',
          matrixParams: 'exact',
          queryParams: 'ignored',
          fragment: 'ignored',
        }
      : { exact: false };
  }
}
